import { de_GetOrderJWTByAccessIdCommand, se_GetOrderJWTByAccessIdCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetOrderJWTByAccessIdCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Api", "GetOrderJWTByAccessId", {})
    .n("ApiClient", "GetOrderJWTByAccessIdCommand")
    .f(void 0, void 0)
    .ser(se_GetOrderJWTByAccessIdCommand)
    .de(de_GetOrderJWTByAccessIdCommand)
    .build() {
}
